import {useState} from 'react';
import {DEFAULT_PAGE_SIZE, DEFAULT_TABLE_DATA} from '../constants';

export const useTabState = ({tabKeys, defaultTableData = DEFAULT_TABLE_DATA, defaultQuery = { per_page: DEFAULT_PAGE_SIZE }}) => {
  const initialTableData = Object.fromEntries(
    tabKeys.map(key => [key, defaultTableData])
  );
  const initialQueries = Object.fromEntries(
    tabKeys.map(key => [key, defaultQuery])
  );
  const initialLoading = Object.fromEntries(
    tabKeys.map(key => [key, false])
  );
  const initialRequiredUpdate = Object.fromEntries(
    tabKeys.map(key => [key, true])
  );
  const initialSelectedRowKeys = Object.fromEntries(
    tabKeys.map(key => [key, []])
  );

  const [tableData, setTableData] = useState(initialTableData);
  const [queries, setQueries] = useState(initialQueries);
  const [loading, setLoading] = useState(initialLoading);
  const [requiredUpdate, setRequiredUpdate] = useState(initialRequiredUpdate);
  const [selectedRowKeys, setSelectedRowKeys] = useState(initialSelectedRowKeys);

  return {
    tableData, setTableData,
    queries, setQueries,
    loading, setLoading,
    requiredUpdate, setRequiredUpdate,
    selectedRowKeys, setSelectedRowKeys
  };
}
